import { CandidateConferenceComponent } from "./candidate-conference.component";
import { AudioVideoConferenceModule } from "../../missioncontrol/conference/conference/audioVideoConference/audio-video-conference.module";
export const CandidateConferenceModule = angular
    .module('candidateConference', [AudioVideoConferenceModule])
    .component(CandidateConferenceComponent.selector, CandidateConferenceComponent.component)
    .name;
//# sourceMappingURL=candidate-conference.module.js.map